import * as HttpService from './HttpService'

let get = (cb, errorCb) => {
    HttpService.get('daily-insight', {}, cb, errorCb)
}

let history = (cb, errorCb) => {
    HttpService.get('daily-insight/history', {}, cb, errorCb)
}

let regenerate = (cb, errorCb) => {
    HttpService.post('daily-insight/regenerate', {}, cb, errorCb)
}

export {
    get,
    history,
    regenerate
}



// WEBPACK FOOTER //
// ./src/services/dailyInsightService.js